var useDisputesFeature = function (_a) {
    var accountFeatures = _a.accountFeatures;
    return Boolean(accountFeatures === null || accountFeatures === void 0 ? void 0 : accountFeatures.accessToDisputes);
};
export default useDisputesFeature;
//# sourceMappingURL=use-disputes-feature.js.map